<template>
  <div class="test" style="text-align:center;width:800px;margin-left:auto;margin-right:auto;">
    <img alt="Vue logo" src="@/assets/IOIHANlogo300x502.png">
    <hr>
    <br>
    <h1>Helpdesk Tickets</h1>
    <!-- The width of the "real" ticket is responsive so testing with various sizes -->
    <div>
      <!-- Just wire in the various events and stub them into simple alerts() is fine -->
        <TicketCard  v-for="(ticket,index) in displayedTickets" :key="index" :ticketIndex="index"
        :ticket="ticket"
        @select="ticketSelect($event)"
        @ticketPin="ticketPin($event)"
        @ticketStar="ticketStar($event)"
        />
    </div>
    <div class="clearfix btn-group col-md-2 offset-md-5">
        <button type="button" class="btn btn-sm btn-outline-secondary" v-if="page != 1" @click="page--"> << </button>
        <button type="button" class="btn btn-sm btn-outline-secondary" v-for="pageNumber in pages.slice(page-1, page+5)" @click="page = pageNumber" :key="pageNumber"> {{pageNumber}} </button>
        <button type="button" @click="page++" v-if="page < pages.length" class="btn btn-sm btn-outline-secondary"> >> </button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import TicketCard from '@/components/TicketCard.vue'

export default {
  name: 'test',
  components: {
    TicketCard
  },
  data() {
    return {
        page: 1,
        perPage: 3,
        pages: [],
        ticket: {},
        tickets: [{
          "client": {
            "clientName": "Courtney"
          },
          "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
          "assignedTo": "daWolf",
          "billable": true,
          "isStar":false,
          "isPin":false,
          "ticketNumber": 23,
          "priority": "normal",
          "tags": ["it", "printer"],
          "title": "Printer is out of toner",
          "description": "Not sure what the model number is ",
          "status": "complete",
          "dueDate": "2019-09-02",
          "_id": "5d66178f8bbadd206cbfa05a",
          "lastUpdateBy": "daWolf",
          "createdAt": "2019-08-28T05:56:31.212Z",
          "updatedAt": "2019-08-29T06:20:28.218Z"
        },
        {
          "client": {
            "clientName": "Wolf"
          },
          "assignedTo": "daWolf",
          "billable": false,
          "isStar":false,
          "isPin":false,
          "ticketNumber": 24,
          "priority": "normal",
          "tags": ["network", "it"],
          "title": "Need another Ethernet Jack",
          "description": "Check with Julie  before starting work",
          "status": "open",
          "dueDate": "2019-08-14",
          "_id": "5d6617958bbadd206cbfa05c",
          "lastUpdateBy": "daWolf",
          "createdAt": "2019-08-28T05:56:37.964Z",
          "updatedAt": "2019-08-29T04:56:45.008Z"
        },
        {
          "client": {
            "clientName": "Captain Kirk"
          },
          "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
          "assignedTo": "daWolf",
          "billable": false,
          "isStar":true,
          "isPin":false,
          "ticketNumber": 25,
          "priority": "critical",
          "tags": ["it"],
          "title": "Need a password reset",
          "description": "on the laptop",
          "status": "open",
          "dueDate": "2019-08-28",
          "_id": "5d6617e18bbadd206cbfa05e",
          "lastUpdateBy": "daWolf",
          "createdAt": "2019-08-28T05:57:53.846Z",
          "updatedAt": "2019-08-28T19:05:20.599Z"
        },
        {
          "client": {
            "clientName": "Wolf"
          },
          "assignedTo": "daWolf",
          "billable": true,
          "isStar":false,
          "isPin":true,
          "ticketNumber": 26,
          "priority": "normal",
          "tags": [],
          "title": "Need phone replaced",
          "description": "not sure who to call",
          "status": "parked",
          "dueDate": "",
          "_id": "5d6617e78bbadd206cbfa060",
          "lastUpdateBy": "daWolf",
          "createdAt": "2019-08-28T05:57:59.404Z",
          "updatedAt": "2019-08-29T06:14:35.960Z"
        },
        {
          "client": {
            "clientName": "Edelgard"
          },
          "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
          "assignedTo": "daWolf",
          "billable": false,
          "isStar":false,
          "isPin":true,
          "ticketNumber": 27,
          "priority": "normal",
          "tags": [],
          "title": "Help setting up my new PC",
          "description": "got a Dell XPS with a graphic accelerator ",
          "status": "open",
          "dueDate": "",
          "_id": "5d66cf5de13baf5b343356c4",
          "lastUpdateBy": "daWolf",
          "createdAt": "2019-08-28T19:00:45.526Z",
          "updatedAt": "2019-08-29T06:08:02.831Z"
        },
        {
          "client": {
            "clientName": "Katheran Janeway"
          },
          "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
          "assignedTo": "daWolf",
          "billable": false,
          "isStar":true,
          "isPin":false,
          "ticketNumber": 29,
          "priority": "critical",
          "tags": ["enterprise"],
          "title": "My Starship will not start",
          "description": "",
          "status": "new",
          "dueDate": "",
          "_id": "5d66d95de13baf5b343356d7",
          "lastUpdateBy": "daWolf",
          "createdAt": "2019-08-28T19:43:25.772Z",
          "updatedAt": "2019-08-28T19:53:10.640Z"
        },
        {
          "client": {
            "clientName": ""
          },
          "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
          "assignedTo": "daWolf",
          "billable": false,
          "isStar":true,
          "isPin":false,
          "ticketNumber": 30,
          "priority": "critical",
          "tags": ["it"],
          "title": "New Ticket",
          "description": "",
          "status": "complete",
          "dueDate": "",
          "_id": "5d66d961e13baf5b343356d9",
          "lastUpdateBy": "daWolf",
          "createdAt": "2019-08-28T19:43:29.753Z",
          "updatedAt": "2019-08-28T19:53:49.192Z"
        },
        {
          "client": {
            "clientName": ""
          },
          "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
          "assignedTo": "daWolf",
          "billable": false,
          "isStar":true,
          "isPin":true,
          "ticketNumber": 31,
          "priority": "normal",
          "tags": [],
          "title": "New Ticket",
          "description": "",
          "status": "stuck",
          "dueDate": "",
          "_id": "5d66d966e13baf5b343356db",
          "lastUpdateBy": "daWolf",
          "createdAt": "2019-08-28T19:43:34.456Z",
          "updatedAt": "2019-08-28T19:53:25.669Z"
        }
      ]
    }
  },
  created() {
      this.setPages();
  },
  computed: {
    displayedTickets () {
        return this.paginate(this.tickets);
    }
  },
  watch: {
    tickets () {
        this.setPages(); // it will call if value get from url/dynamically
    }
  },
  methods: {
    ticketSelect(id) {
      alert("You selected ticket: " + id);
    },
    ticketPin(ticketIndex) {
        this.tickets[ticketIndex].isPin = !this.tickets[ticketIndex].isPin
     // alert("You selected ticket: " + ticketIndex);
    },
    ticketStar(ticketIndex) {
        this.tickets[ticketIndex].isStar = !this.tickets[ticketIndex].isStar
      //alert("You selected ticket: " + ticketIndex);
    },
    setPages () {
        let numberOfPages = Math.ceil(this.tickets.length / this.perPage);
        for (let index = 1; index <= numberOfPages; index++) {
            this.pages.push(index);
        }
    },
    paginate (tickets) {
        let page = this.page;
        let perPage = this.perPage;
        let from = (page * perPage) - perPage;
        let to = (page * perPage);
        console.log("debugger")
        return  tickets.slice(from, to);
    }
  }
}
</script>
<style lang="scss">

  .show-hand {
    cursor:pointer;
  }

</style>